import { render } from "./Guide_Meals.vue?vue&type=template&id=86808dec"
import script from "./Guide_Meals.vue?vue&type=script&lang=js"
export * from "./Guide_Meals.vue?vue&type=script&lang=js"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__